import colors from '../colors';
import * as React from 'react';
import styled, { StyledFunction, keyframes } from 'styled-components';
import { User } from '../../typedefs/store';
import AnonymousAvatar from './AnonymousAvatar';

interface Props {
    avatar: string;
    showAvatars?: boolean;
}

const TypingMessage: React.SFC<Props> = ({ avatar, showAvatars }) => (
    <Wrapper className="conversations-message-item conversations-message-container conversations-message-typing">
        {showAvatars && (
            <AvatarWrapper className="conversations-message-avatar">
                {avatar ? <Avatar src={avatar} /> : <AnonymousAvatar />}
            </AvatarWrapper>
        )}
        <Bubble className="conversations-message-content">
            <AnimationWrapper className="conversations-message-body">
                <Dot />
                <Dot />
                <Dot />
            </AnimationWrapper>
        </Bubble>
    </Wrapper>
);

export default TypingMessage;

const div: StyledFunction<{ type: string } & React.HTMLProps<HTMLElement>> = styled.div;

const Wrapper = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    margin-bottom: 0;
`;

const AvatarWrapper = styled.div`
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 10px;
    margin-left: 0;
    height: 30px;
    width: 30px;
    order: 0;
`;

const Avatar = styled.img`
    width: 30px;
    height: 30px;
    border-radius: 50%;
`;

const Bubble = styled.div`
    border-radius: 10px 10px 10px 0;
    background-color: ${props => props.theme.messageBubble.agent.bgColor};
    color: ${props => props.theme.messageBubble.agent.fgColor};
    margin-right: 0;
    margin-left: 6px;
    padding: 10px;
    position: relative;
    word-break: break-word;

    &:before {
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        right: auto;
        left: -6px;
        bottom: 0;
        border: 3px solid;
        border-color: ${props =>
            `transparent ${props.theme.messageBubble.agent.bgColor} ${props.theme.messageBubble
                .agent.bgColor} transparent`};
    }
`;

const Wave = keyframes`
    0%, 60%, 100% {
        transform: initial;
    }
    30% {
        transform: translateY(-10px);
    }
`;

const AnimationWrapper = styled.div`
    position: relative;
    text-align: center;
`;

const Dot = styled.span`
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 3px;
    background: ${props => props.theme.messageBubble.agent.fgColor};
    animation: ${Wave} 1.3s linear infinite;

    &:nth-child(2) {
        animation-delay: -1.1s;
    }

    &:nth-child(3) {
        animation-delay: -0.9s;
        margin-right: 0;
    }
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/TypingMessage.tsx